import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getClient, activateClientAfterDeposit } from '../../services/clientService';

export default function ClientDepositSuccess() {
  const { id } = useParams();
  const [client, setClient] = useState(null);
  const [activating, setActivating] = useState(true);

  useEffect(() => {
    const activate = async () => {
      try {
        const data = await getClient(id);
        if (data && !data.depositPaid) {
          // Activate (the webhook will also do this, but we do it client-side for instant feedback)
          const urlParams = new URLSearchParams(window.location.search);
          const sessionId = urlParams.get('session_id') || 'manual';
          await activateClientAfterDeposit(id, sessionId);
          setClient({ ...data, depositPaid: true, accessEnabled: true });
        } else {
          setClient(data);
        }
      } catch (err) {
        console.error('Activation error:', err);
      } finally {
        setActivating(false);
      }
    };

    if (id) activate();
  }, [id]);

  if (activating) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-apn-blue mx-auto mb-4"></div>
          <p className="text-gray-600">Activating your preview access...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 px-4">
      <div className="sm:mx-auto sm:w-full sm:max-w-lg text-center">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mb-2">Deposit Received!</h2>
          <p className="text-gray-600 mb-6">
            Your $5 deposit has been processed successfully. Your 48-hour preview access is now active.
          </p>

          {client && (
            <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left space-y-2">
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Company</span>
                <span className="font-medium">{client.companyName}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Access Code</span>
                <span className="font-mono font-bold text-apn-blue tracking-wider">{client.accessCode}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Email</span>
                <span className="font-medium">{client.contactEmail}</span>
              </div>
            </div>
          )}

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-sm text-left">
            <p className="text-blue-800 font-semibold mb-1">Your login credentials:</p>
            <p className="text-blue-700">
              Use your email (<strong>{client?.contactEmail}</strong>) and access code (<strong className="font-mono">{client?.accessCode}</strong>) to log in at any time during your 48-hour window.
            </p>
          </div>

          <Link
            to="/client/login"
            className="inline-flex items-center px-6 py-3 bg-apn-blue text-white font-semibold rounded-lg hover:bg-apn-dark-blue transition-colors"
          >
            Go to Client Portal
          </Link>
        </div>
      </div>
    </div>
  );
}
